import { useSelector } from "react-redux";

import { getNodeTypeIdSelector } from "@skilitics/nautilus-core-designer-data";

export const useGetNodeTypeId = () => useSelector(getNodeTypeIdSelector);
